import setAbas from './pages/setAbas';
import setFaq from './pages/setFaq';
//addImports

const Page = {
  init: function () {
    var _this = this; 
    if (document.querySelector('[data-tab]')) {
      setAbas();

      window.addEventListener('hashchange', function () {
        setAbas();
      });
    }
    if (document.querySelector('[data-collapse]')) setFaq();
    //calls
  },
};

window.addEventListener('DOMContentLoaded', () => {
  Page.init();
});
